
/* START_TEMPLATE */
define('hbs!app/templates/recipient_information',['hbs','Handlebars', 'hbs!app/templates/_rows','app/templates/_helpers/subview'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "<div class=\"at-row\">\n        ";
  stack1 = ((helpers.subview || (depth0 && depth0.subview) || helperMissing).call(depth0, (depth0 != null ? depth0.includeRecipient : depth0), {"name":"subview","hash":{}}));
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\n    </div>\n";
},"3":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.subview || (depth0 && depth0.subview) || helperMissing).call(depth0, depth0, {"name":"subview","hash":{}}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<div class=\"at-fields\">";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.includeRecipient : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  buffer += "    <div class=\"at-recipient-info\">\n        <div class=\"at-title\">"
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{}}) : helper)))
    + "</div>\n";
  stack1 = this.invokePartial(partials['./_rows'], '        ', './_rows', depth0, undefined, helpers, partials);
  if (stack1 != null) { buffer += stack1; }
  buffer += "    </div>\n    <div class=\"at-row\">\n        <div class=\"at-recipient-msg\">";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.notificationFields : depth0), {"name":"each","hash":{},"fn":this.program(3, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\n    </div>\n</div>";
},"usePartial":true});
Handlebars.registerPartial('app/templates/recipient_information', t);
return t;
});
/* END_TEMPLATE */
;
